import React from "react";

const FindingDropIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM4.37574 6.37574C4.14142 6.61005 4.14142 6.98995 4.37574 7.22426L7.57574 10.4243C7.81005 10.6586 8.18995 10.6586 8.42426 10.4243L11.6243 7.22426C11.8586 6.98995 11.8586 6.61005 11.6243 6.37574C11.3899 6.14142 11.0101 6.14142 10.7757 6.37574L8 9.15147L5.22426 6.37574C4.98995 6.14142 4.61005 6.14142 4.37574 6.37574Z"
        fill="#BEBEBE"
      />
    </svg>
  );
};

export default FindingDropIcon;
